import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.CustomerInitiatedEscalationsCollectProfile,
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedMessage,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedCollectionMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedContactMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedWantShortProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedWantSecondaryOptional,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingHumanInitiatedWantShortProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingHumanInitiatedWantConfirmProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="When a user asks to speak with a human, collect their contact information before escalating.">
        Customer Initiated Escalation
      </PageHeader>

      <SwitchRow
        {...page}
        keyName={LocationVarKey.CustomerInitiatedEscalationsCollectProfile}
        label="Collect Profile"
        hideIf={IS_EQUAL(LocationVarKey.WantsCustomerInitiatedEscalations, "0")}
      />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.CustomerInitiatedEscalationsCollectProfile, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProfileSettingHumanInitiatedMessage} />
        <DropdownRow
          {...page}
          marginTop
          label=" Collection Method"
          keyName={LocationVarKey.ProfileSettingHumanInitiatedCollectionMethod}
          options={[
            {
              label: "Conversational",
              value: "Conversational"
            },
            {
              label: "Info Collect Card",
              value: "Card"
            }
          ]}
        />
        <DropdownRow
          {...page}
          marginTop
          label=" Preferred Contact Method"
          keyName={LocationVarKey.ProfileSettingHumanInitiatedContactMethod}
          options={[
            {
              label: "Phone Number",
              value: "Phone"
            },
            {
              label: "Email",
              value: "Email"
            }
          ]}
        />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingHumanInitiatedWantShortProfile} label="Short Profile" />
        <Indent {...page}>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.ProfileSettingHumanInitiatedWantSecondaryOptional}
            hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingHumanInitiatedWantShortProfile, "1")}
            label="Make Secondary Contact Method Optional"
          />
        </Indent>
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingHumanInitiatedWantConfirmProfile} label="Confirm Profile" />
      </Section>
    </>
  );
}
